import React, { useMemo } from 'react';
import type { TravelerFields, TravelerFormValues } from '../../../api/reservationInfo';
import { createTravelerFieldRules } from './utils';
import ReservationInfoAirKanaFields from './air_fields/ReservationInfoAirKanaFields';
import ReservationInfoAirRomanFields from './air_fields/ReservationInfoAirRomanFields';
import ReservationInfoAirBirthdayField from './air_fields/ReservationInfoAirBirthdayField';
import ReservationInfoAirGenderField from './air_fields/ReservationInfoAirGenderField';
import ReservationInfoAirPassportFields from './air_fields/ReservationInfoAirPassportFields';
import ReservationInfoAirTelField from './air_fields/ReservationInfoAirTelField';
import ReservationInfoAirMileageField from './air_fields/ReservationInfoAirMileageField';
import ReservationInfoAirSeatField from './air_fields/ReservationInfoAirSeatField';

type Props = {
  travelerFields: TravelerFields;
  traveler: TravelerFormValues;
  travelerErrors: Partial<Record<keyof TravelerFormValues, string>>;
  onTextChange: (field: keyof TravelerFormValues) => (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSelectChange: (field: keyof TravelerFormValues) => (e: React.ChangeEvent<HTMLSelectElement>) => void;
  disabled: boolean;
  title: string;
  telLabel: string;
};

const ReservationInfoAirSection = ({
  travelerFields,
  traveler,
  travelerErrors,
  onTextChange,
  onSelectChange,
  disabled,
  title,
  telLabel
}: Props) => {
  const travelerFieldRules = useMemo(() => createTravelerFieldRules(travelerFields), [travelerFields]);

  return (
    <div style={styles.section}>
      <h4 style={styles.sectionTitle}>{title}</h4>
      <ReservationInfoAirKanaFields
        travelerFieldRules={travelerFieldRules}
        traveler={traveler}
        travelerErrors={travelerErrors}
        onTextChange={onTextChange}
        disabled={disabled}
      />

      <ReservationInfoAirRomanFields
        travelerFieldRules={travelerFieldRules}
        traveler={traveler}
        travelerErrors={travelerErrors}
        onTextChange={onTextChange}
        disabled={disabled}
      />
      <ReservationInfoAirBirthdayField
        travelerFieldRules={travelerFieldRules}
        traveler={traveler}
        travelerErrors={travelerErrors}
        onTextChange={onTextChange}
        disabled={disabled}
      />
      <ReservationInfoAirGenderField
        travelerFieldRules={travelerFieldRules}
        traveler={traveler}
        travelerErrors={travelerErrors}
        onSelectChange={onSelectChange}
        disabled={disabled}
      />

      <ReservationInfoAirPassportFields
        travelerFieldRules={travelerFieldRules}
        traveler={traveler}
        travelerErrors={travelerErrors}
        onTextChange={onTextChange}
        disabled={disabled}
      />
      <ReservationInfoAirTelField
        travelerFieldRules={travelerFieldRules}
        traveler={traveler}
        travelerErrors={travelerErrors}
        onTextChange={onTextChange}
        disabled={disabled}
        telLabel={telLabel}
      />
      <ReservationInfoAirMileageField
        travelerFieldRules={travelerFieldRules}
        traveler={traveler}
        travelerErrors={travelerErrors}
        onTextChange={onTextChange}
        disabled={disabled}
      />
      <ReservationInfoAirSeatField
        travelerFieldRules={travelerFieldRules}
        traveler={traveler}
        onSelectChange={onSelectChange}
        disabled={disabled}
      />
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  section: {
    marginTop: '20px',
    paddingTop: '16px',
    borderTop: '1px solid #ddd'
  },
  sectionTitle: {
    fontSize: '14px',
    fontWeight: 'bold',
    marginBottom: '12px',
    marginTop: 0,
    color: '#555'
  }
};

export default ReservationInfoAirSection;
